export default {
  getIcpCloudProviders: (state) => state.icpCloudProviders,
  getIcpCloudSignatureJwt: (state) => state.icpCloudSignatureJwt,
  getIcpCloudSignatureInfo: (state) => state.icpCloudSignatureInfo,
};
